import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Componente reutilizable para estados vacíos.
 * Muestra icono o ilustración SVG + mensaje y CTA opcional.
 */
export default function EmptyState({ message = 'Sin datos', icon = 'bi bi-inbox', actionLabel, actionLink, onAction, height = 160 }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ py: 3, minHeight: height }}
    >
      {icon && <i className={icon} style={{ fontSize: 48, opacity: 0.4 }} />}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: actionLabel ? 2 : 0 }}>
        {message}
      </Typography>
      {actionLabel && (
        onAction ? (
          <Button onClick={onAction} variant="contained" size="small">
            {actionLabel}
          </Button>
        ) : (
          actionLink && (
            <Button component={RouterLink} to={actionLink} variant="contained" size="small">
              {actionLabel}
            </Button>
          )
        )
      )}
    </Box>
  );
}

EmptyState.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.string,
  actionLabel: PropTypes.string,
  actionLink: PropTypes.string,
  onAction: PropTypes.func,
  height: PropTypes.number,
};
